import { render, staticRenderFns } from "./postponeDialog.vue?vue&type=template&id=170b505e"
import script from "./postponeDialog.vue?vue&type=script&lang=js"
export * from "./postponeDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports